/*
 * Yoni cart page — line-level edits via Shopify's AJAX Cart API (/cart/change.js),
 * then a reload to re-render totals. Progressive: the checkout button and links
 * work without JS; these handlers just make qty / plan / remove instant.
 * Re-initialises when the theme editor re-renders the cart section.
 */
(function () {
  function change(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed');
      return r.json();
    });
  }
  function reload() { window.location.reload(); }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initCart(scope) {
    var root = (scope || document).querySelector('[data-yoni-cart]');
    if (!root || root.dataset.yoniCartInit === '1') return;
    root.dataset.yoniCartInit = '1';

    root.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;

      var down = line.querySelector('[data-qty-down]');
      var up = line.querySelector('[data-qty-up]');
      var rm = line.querySelector('[data-remove]');
      var sub = line.querySelector('[data-plan-toggle="subscribe"]');
      var one = line.querySelector('[data-plan-toggle="onetime"]');
      var freq = line.querySelector('[data-freq-select]');

      function busy() { line.setAttribute('aria-busy', 'true'); line.style.opacity = '0.55'; }
      function act(body) { busy(); change(body).then(reload).catch(reload); }

      if (down) down.addEventListener('click', function () { act({ id: key, quantity: Math.max(0, qty - 1) }); });
      if (up) up.addEventListener('click', function () { act({ id: key, quantity: qty + 1 }); });
      if (rm) rm.addEventListener('click', function () { act({ id: key, quantity: 0 }); });
      if (sub) sub.addEventListener('click', function () {
        var plan = (freq && freq.value) || sub.getAttribute('data-plan-id');
        act({ id: key, quantity: qty, selling_plan: plan });
      });
      if (one) one.addEventListener('click', function () { act({ id: key, quantity: qty, selling_plan: null }); });
      if (freq) freq.addEventListener('change', function () { act({ id: key, quantity: qty, selling_plan: freq.value }); });
    });

    // "Switch & save": move every one-time line onto its default subscription plan.
    var switchAll = root.querySelector('[data-switch-all]');
    if (switchAll) {
      switchAll.addEventListener('click', function () {
        var lines = Array.prototype.slice.call(root.querySelectorAll('[data-cart-line][data-onetime="true"]'));
        if (!lines.length) return;
        switchAll.setAttribute('aria-busy', 'true');
        (function next(i) {
          if (i >= lines.length) return reload();
          var l = lines[i];
          var plan = l.getAttribute('data-default-plan');
          if (!plan) return next(i + 1);
          change({
            id: l.getAttribute('data-line-key'),
            quantity: parseInt(l.getAttribute('data-qty'), 10) || 1,
            selling_plan: plan,
          }).then(function () { next(i + 1); }).catch(function () { next(i + 1); });
        })(0);
      });
    }
  }

  ready(function () { initCart(document); });
  document.addEventListener('shopify:section:load', function (e) { initCart(e.target); });
})();
